import { FC } from 'react';
import { Patient, Encounter } from '@medplum/fhirtypes';
import { useTranslation } from 'react-i18next';
import { EncounterForm } from '@/components/forms/EncounterForm';

interface PatientOnboardingEncounterFormProps {
  patient: Patient;
  onEncounterCreated: (encounter: Encounter) => void;
  onBack: () => void;
}

/**
 * Encounter creation form for patient onboarding workflow
 * Wrapper around the unified EncounterForm component for onboarding workflow
 *
 * @param props - Component props
 * @param props.patient - The patient for this encounter
 * @param props.onEncounterCreated - Callback when encounter is created
 * @param props.onBack - Callback to go back to previous step
 * @returns JSX.Element
 */
export const PatientOnboardingEncounterForm: FC<PatientOnboardingEncounterFormProps> = ({
  patient,
  onEncounterCreated,
  onBack,
}) => {
  const { t } = useTranslation('patient-onboarding');

  return (
    <EncounterForm
      patient={patient}
      onEncounterCreated={onEncounterCreated}
      onBack={onBack}
      showPatientInfo={true}
      showAdditionalNotes={true}
      submitButtonText={t('encounter.createEncounterButton')}
    />
  );
};
